import { topicItems } from "@/mocks/gossip";

const ICONS = [
  "ri-user-unfollow-line",
  "ri-bar-chart-2-line",
  "ri-film-line",
  "ri-shopping-cart-2-line",
  "ri-file-copy-2-line",
  "ri-refresh-line",
  "ri-shield-check-line",
  "ri-user-voice-line",
];

export default function Topics() {
  return (
    <section id="topics" className="scroll-mt-20 bg-background-100 py-14 md:py-20 border-y border-background-200">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-primary-600">
            <span className="h-px w-8 bg-primary-400"></span> 话题库
          </p>
          <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950">
            按话题把黑料整理成册
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            翻车类型五花八门，别让零碎素材淹没了真相。我们按争议方向建立话题档案，点进任一分类即可直达该方向下的完整证据链与人物梳理。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {topicItems.map((t, idx) => (
            <a
              key={t.id}
              href="#archive"
              className="group rounded-2xl bg-background-50 border border-background-200 p-5 hover:border-primary-300 hover:-translate-y-1 transition-all"
            >
              <div className="flex items-center justify-between">
                <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${ICONS[idx % ICONS.length]} text-xl`}></i>
                </span>
                <span className="rounded-full bg-accent-100 text-accent-800 px-2.5 py-1 text-[11px] font-medium whitespace-nowrap">
                  {t.count}
                </span>
              </div>
              <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">
                {t.name}
              </h3>
              <p className="font-latin text-[11px] tracking-[0.18em] text-primary-600 uppercase mt-0.5">
                {t.en}
              </p>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                {t.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 group-hover:gap-2.5 transition-all whitespace-nowrap">
                查看档案 <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}